import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";
import Chatbot from "./Chatbot";



const Chatbotsinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "Chatbot | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="Chatbot" pagesub=" Chatbot" />
                       <Chatbot></Chatbot>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default Chatbotsinglepage;
